import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import type { NgrxRoute } from '@core/ngrx-legacy';
import { ProtectedControlsGuardService } from '@core/user-interface-legacy';

import { ActivityPageComponent } from './activity/activity-page.component';
import { DetailsPageComponent } from './details/details-page.component';
import { FilesPageComponent } from './files/files-page.component';
import { FlowPageComponent } from './flow/flow-page.component';
import { HiresPageComponent } from './hires/hires-page.component';
import { JobsPageComponent } from './jobs/jobs-page.component';
import { NotesPageComponent } from './notes/notes-page.component';
import { RootPageComponent } from './root/root-page.component';
import { TeamPageComponent } from './team/team-page.component';
import { RequisitionDetailsGuard } from '../../guards/requisition-details.guard';
import { RequisitionsPageGuard } from '../../guards/requisitions-page.guard';
import { RequisitionActivitiesResolver } from '../../resolvers/requisition-activities.resolver';
import { RequisitionFilesResolver } from '../../resolvers/requisition-files.resolver';
import { RequisitionFlowResolver } from '../../resolvers/requisition-flow.resolver';
import { RequisitionJobsResolver } from '../../resolvers/requisition-jobs.resolver';
import { RequisitionNotesResolver } from '../../resolvers/requisition-notes.resolver';
import { RequisitionRootResolver } from '../../resolvers/requisition-root.resolver';

const routes: NgrxRoute[] = [
  {
    path: '',
    component: RootPageComponent,
    canActivate: [RequisitionsPageGuard],
    canDeactivate: [ProtectedControlsGuardService],
    resolve: { fetchData: RequisitionRootResolver },
    data: {
      view: 'requisition',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'details',
      },
      {
        path: 'details',
        component: DetailsPageComponent,
        data: {
          title: 'requisitions_details',
        },
        canDeactivate: [RequisitionDetailsGuard],
      },
      {
        path: 'flow',
        component: FlowPageComponent,
        data: {
          title: 'requisitions_flow',
        },
        resolve: {
          fetchData: RequisitionFlowResolver,
        },
      },
      {
        path: 'hires',
        component: HiresPageComponent,
        data: {
          title: 'requisitions_hires',
        },
      },
      {
        path: 'jobs',
        component: JobsPageComponent,
        data: {
          title: 'requisitions_jobs',
        },
        resolve: {
          fetchData: RequisitionJobsResolver,
        },
      },
      {
        path: 'notes',
        component: NotesPageComponent,
        data: {
          title: 'requisitions_notes',
        },
        resolve: {
          fetchData: RequisitionNotesResolver,
        },
      },
      {
        path: 'files',
        component: FilesPageComponent,
        data: {
          title: 'requisitions_files',
        },
        resolve: {
          fetchData: RequisitionFilesResolver,
        },
      },
      {
        path: 'team',
        component: TeamPageComponent,
        data: {
          title: 'requisitions_team',
        },
      },
      {
        path: 'activity',
        component: ActivityPageComponent,
        data: {
          title: 'requisitions_activity',
        },
        resolve: {
          fetchData: RequisitionActivitiesResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [
    RequisitionRootResolver,
    RequisitionFlowResolver,
    RequisitionNotesResolver,
    RequisitionFilesResolver,
    RequisitionJobsResolver,
    RequisitionActivitiesResolver,
    RequisitionDetailsGuard,
  ],
})
export class SingleRequisitionModule {}
